var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper"},[_c('div',{staticClass:"chart-container"},[_c(_vm.chartComponent,{key:_vm.chartBodyKey,ref:"chartBody",tag:"component",attrs:{"message":_vm.message}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }